import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import logoLight from '../../imgs/logo-light.png';
import logoDark from '../../imgs/logo-dark.png';

const FooterWrapper = styled.footer`
  padding: 3rem 2rem;
  border-top: 1px solid ${({ theme }) => theme.colors.border || 'rgba(0,0,0,0.1)'};
  background: ${({ theme }) => theme.colors.background};
`;

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
`;

const LogoImg = styled.img`
  height: 32px;
  width: auto;
`;

const Links = styled.div`
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
`;

const Link = styled.a`
  color: ${({ theme }) => theme.colors.paragraph};
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s;
  
  &:hover {
    color: ${({ theme }) => theme.colors.activeColor};
  }
`;

const Copyright = styled.p`
  color: ${({ theme }) => theme.colors.paragraph}99;
  font-size: 0.85rem;
  text-align: center;
`;

const LandingFooter = () => {
  const year = new Date().getFullYear();
  const theme = useContext(ThemeContext);
  const logo = theme.name === 'dark-theme' ? logoLight : logoDark;
  
  return (
    <FooterWrapper>
      <Container>
        <LogoImg src={logo} alt="PropNinja" />
        <Links>
          <Link href="mailto:support@propninja.ai">Contact</Link>
          <Link href="/privacy">Privacy Policy</Link>
          <Link href="/terms">Terms of Service</Link>
        </Links>
        <Copyright>
          © {year} PropNinja. All rights reserved.
        </Copyright>
      </Container>
    </FooterWrapper>
  );
};

export default LandingFooter;
